// ============================================================
// TARIFS & OPTIONS — modifiables en toute simplicité
// ------------------------------------------------------------
// 🛠️ Modifiez les nombres ci-dessous pour ajuster les prix.
// Le calculateur de la page /tarifs les utilise automatiquement.
// ============================================================

export const PRICING = {
  // Nuit de base (semaine) — pour 2 personnes
  baseNight: 150,

  // Nombre de personnes inclus dans le tarif de base
  basePeople: 2,

  // Supplément par voyageur au-delà de basePeople (par nuit)
  extraPerson: 15,

  // Nombre de nuits d'un séjour "week-end"
  weekendNights: 2,

  // Nombre de personnes maximum
  maxPeople: 3,

  // Options — prix des expériences ajoutables
  options: {
    bainDeFleurs: 70,   // par bain (forfait par séjour)
    petitDejeuner: 25,  // par personne, par matin
    decors: 50,         // par séjour (forfait)
  },

  // Taxe de séjour (règle Curieux Refuge · Saint-Paul, La Réunion)
  // Reversée intégralement à la collectivité. Logique Lodgify / TCO :
  //   • rate                     → taxe = (prix hébergement ÷ nuits ÷ occupants totaux) × rate
  //   • perPersonPerNightCap     → plafond réglementaire par personne assujettie & par nuit
  //   • seuls les ADULTES sont assujettis (les enfants comptent dans le diviseur mais sont exonérés)
  //   • les extras (petit-déj, bain, décor) sont EXCLUS de la base de calcul
  cityTax: {
    rate: 0.05,                 // 5 % — taux applicable pour un meublé non classé
    perPersonPerNightCap: 5.00, // plafond régulatoire (€ / adulte / nuit) — configuré pour Curieux Refuge (Lodgify)
    perPersonPerNight: 2,       // ⚠️ ancien mode (taxe fixe) conservé pour /bon-cadeau uniquement
  },
};

// Cards tarifs affichées en bas de page /tarifs
export const PRICING_CARDS = {
  semaine: {
    eyebrow: "En semaine",
    title: "Une nuit",
    titleItalic: "au refuge",
    price: "≈ 150€",
    unit: "la nuit · pour 2 personnes",
    extra: "+15€ / voyageur supplémentaire",
  },
  weekend: {
    eyebrow: "Week-end",
    title: "Séjour",
    titleItalic: "week-end",
    price: "≈ 300€",
    unit: "pour 2 nuits · pour 2 personnes",
    highlights: [
      "Arrivée vendredi · 16h",
      "Départ dimanche · 12h",
      "+15€ / voyageur supplémentaire",
    ],
    badge: "Favori",
  },
};

export default PRICING;
